import { createFileRoute } from "@tanstack/react-router";
import { MenuListing, menuQuery, COCKTAIL_CATEGORIES } from "@/components/MenuListing";
import cocktailsMenuBg from "@/assets/cocktails-menu-bg.jpg.asset.json";

export const Route = createFileRoute("/cocktails")({
  loader: ({ context }) => context.queryClient.ensureQueryData(menuQuery),
  head: () => {
    const ogImage = "https://plunkets.ie/og-cocktails.jpg?v=2";
    return {
      meta: [
        { title: "Cocktail Bar Dublin City Centre — 2 for €18 Cocktails | Plunkets Pub" },
        { name: "description", content: "The cocktail pub in Dublin city centre. 20+ signature & classic cocktails, 2 for €18 all night Monday to Thursday at Plunkets, Middle Abbey Street, Dublin 1." },
        { name: "keywords", content: "cocktail bar Dublin, cocktail pub Dublin city centre, 2 for €18 cocktails Dublin, cocktail menu Dublin" },
        { property: "og:title", content: "Cocktail Bar in Dublin City Centre — Plunkets" },
        { property: "og:description", content: "20+ cocktails, 2 for €18 Mon–Thu in Dublin city centre." },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://plunkets.ie/cocktails" },
        { property: "og:image", content: ogImage },
        { property: "og:image:width", content: "1200" },
        { property: "og:image:height", content: "630" },
        { property: "og:locale", content: "en_IE" },
        { property: "og:site_name", content: "Plunkets Pub Dublin" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: "Cocktail Bar in Dublin City Centre — Plunkets" },
        { name: "twitter:description", content: "20+ cocktails, 2 for €18 Mon–Thu at Plunkets Pub." },
        { name: "twitter:image", content: ogImage },
      ],
      links: [{ rel: "canonical", href: "https://plunkets.ie/cocktails" }],
    };
  },
  component: CocktailsOnlyPage,
});

function CocktailsOnlyPage() {
  return (
    <MenuListing
      eyebrow="Drink"
      title={<>Cocktail <span className="text-gold-gradient">Bar</span></>}
      description="Around 20 cocktails poured by bartenders who take it seriously. Signature builds, classics done right, and pitchers of beer to share."
      backgroundUrl={cocktailsMenuBg.url}
      allowedCategories={COCKTAIL_CATEGORIES}
      showDealsFilter
      promoBadge="2 cocktails for €18 all night · Mon–Thu"
    />
  );
}
